<template>
  <div>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to remove this {{ removeItem }}?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="secondary-btn btn-padding-medium mb-2"
            text
            @click="dialog = false"
          >
            No
          </v-btn>

          <v-btn
            class="primary-btn btn-padding-medium mb-2"
            text
            @click="
              dialog = false;
              $emit('removeButtonToggled');
            "
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn class="close-btn" top right absolute @click.stop="dialog = true"
      >Remove test</v-btn
    >
  </div>
</template>

<script>
export default {
  props: ["removeItem"],
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
<style scoped>
.close-btn {
  border: 2px solid #bf0000;
  background: #fff !important;
  box-shadow: none !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-top: 22px !important;
  padding-bottom: 22px !important;
  margin-right: 70px;
}

.close-btn:hover {
  background: #bf0000 !important;
  color: white;
  transition: 0.2s;
}
</style>
